<template>
  <div class="cmp-order-product normalize-headers" :class="parentClassRef">

    <utlz-order-normal v-if="orderType === 'normal'"
                       @orderNormal="orderProductNormal($event)"></utlz-order-normal>

    <utlz-order-saleunit v-if="orderType === 'saleUnit'"
                         :saleUnit="product.saleUnit"></utlz-order-saleunit>

    <!-- BESPOKE EDEX: Disable standard units dropdown if we are using the product details page, 
     so we can show quantity buttons for each unit instead -->
     <template v-if="!useUnitsLayout">
      <utlz-order-units v-if="orderType === 'units' && product.stock"
                      :units="product.units"
                      :stockProduct="stockProduct"
                      :stockTotal="product.stock.stockTotal"
                      :selectedUnitCode="selectedUnitCode"
                      @unitsChanged="unitsChanged($event)"></utlz-order-units>
     </template>
    <!-- END BESPOKE EDEX -->

    <utlz-order-grouped v-if="orderType === 'grouped'" :product="product"></utlz-order-grouped>

    <utlz-order-volume-discount v-if="orderType === 'volumeDiscount'"
                                :volumeDiscount="product.prices"
                                @volumeDiscountChanged="volumeDiscountChanged($event)">
    </utlz-order-volume-discount>

    <input v-if="useOrderComment" type="text" :value="orderCommentField" ref="orderComment" class="order-comment">

    <!-- <div class="order-product-wrapper flex-row-nowrap" :class="{ 'disabled': stockLimit && !isValidQuantity }"> -->
    <div class="order-product-wrapper flex-row-nowrap">

      <!-- BESPOKE EDEX: 
        - Show different quantity buttons if we are on the product details page
        - Added quantity message for the units  
      -->
      <template v-if="!useUnitsLayout">        
        <utlz-quantity-buttons :initialQuantity="quantity"
                              :allowZeroQuantity="false"
                              :quantityFactor="quantityFactor"
                              @quantityChanged="quantityChanged($event)">
        </utlz-quantity-buttons>
        <div class="quantity-message">
          <span>{{ quantity }}</span> x <span>{{ selectedUnitFactor }}</span> = <span>{{ quantity * selectedUnitFactor }}</span>
        </div>    
        <a v-if="useOrderMode" @click="orderProduct" class="button add-to-cart-btn small">
          <!-- BESPOKE EDEX-40: Changed icon -->
          <i class="material-icons-outlined">shopping_cart</i>
          <!-- END BESPOKE EDEX-40 -->
        </a>
      </template>

      <template v-else>
        <div class="custom-unit-layout">
          <div v-for="(unit, ind) in product.units" :key="'unit-row-' + componentKey + ind" class="unit-row">
            <utlz-quantity-buttons :initialQuantity="customUnits[unit.code].selectedQuantity"
                                  :allowZeroQuantity="true"
                                  :quantityFactor="1"
                                  @quantityChanged="customQuantityChanged($event, unit.code)">
            </utlz-quantity-buttons>
            <span class="unit-display">
              {{ customUnits[unit.code].description }}
              (<span v-translation="{ type: 'label', code: 'label_unit_content' }"></span>: {{ customUnits[unit.code].quantity }}<span class="label-pcs" v-translation="{ type: 'label', code: 'label_unit_pcs' }"></span>)            
            </span>
            
            <div class="ean-code" v-if="customUnits[unit.code].eanCode.length">
              <span v-translation="{code: 'ean_code_description', type: 'label' }" class="ean-label"></span>
              <span>{{ customUnits[unit.code].eanCode}}</span>
            </div>

          </div> 

          <a v-if="useOrderMode" @click="orderProductAsUnits" class="button add-to-cart-btn small">
            <i class="material-icons-outlined">shopping_cart</i>
            <span v-translation="{ code: 'button_order', type: 'button' }"></span>
          </a>
        </div>
      </template>
      <!-- END BESPOKE EDEX-46 -->      

      <!-- BESPOKE EDEX: Disabled stock limit tooltip -->
      <!-- Displays stocklimit exceeded tooltip -->
      <!-- <transition name="fade">
        <template v-if="stockLimit && !isValidQuantity">
          <div class="utlz-tooltip stock-limit danger">
            <p v-translation="{ type: 'label', code: 'label_exceeds_stock_limit' }"></p>
          </div>
        </template>
      </transition> -->
      <!-- END BESPOKE EDEX -->

    </div>

  </div>
</template>

<script>
  import OrderNormal from 'src/components/webshop/order-product/blocks/OrderNormal.vue';
  import OrderSaleUnit from 'src/components/webshop/order-product/blocks/OrderSaleUnit.vue';
  import OrderUnits from 'src/components/webshop/order-product/blocks/OrderUnits.vue';
  import OrderGrouped from 'src/components/webshop/order-product/blocks/OrderGrouped.vue';
  import OrderVolumeDiscount from 'src/components/webshop/order-product/blocks/OrderVolumeDiscount.vue';
  import QuantityButtons from 'src/components/webshop/order-product/blocks/QuantityButtons.vue';
  import { mapGetters, mapActions } from 'vuex';

  export default {
    components: {
      'utlz-order-normal': OrderNormal,
      'utlz-order-saleunit': OrderSaleUnit,
      'utlz-order-units': OrderUnits,
      'utlz-order-grouped': OrderGrouped,
      'utlz-order-volume-discount': OrderVolumeDiscount,
      'utlz-quantity-buttons': QuantityButtons
    },
    props: {
      product: { type: Object, required: true },
      initialQuantity: { type: Number, required: false, default: 1 },
      initialUnitCode: { type: String, required: false },
      useOrderComment: { type: Boolean, required: false, default: false },
      orderComment: { type: String, required: false },
      useOrderMode: { type: Boolean, default: true },
      totalOrderLinesQuantity: { type: Number, required: false, default: null },
      allowZeroQuantity: { type: Boolean, required: false, default: false },
      parentClassRef: { type: String, default: '', required: false },
      // BESPOKE EDEX
      productDetailsPage: { type: Boolean, default: false }
      // END BESPOKE EDEX
    },
    data() {
      return {
        stockProduct: this.product.customBooleans.STOCK_PRODUCT,
        quantity: this.initialQuantity,
        quantityFactor: 1,
        orderType: 'normal',
        selectedUnitCode: '',
        // BESPOKE EDEX
        customUnits: {},
        componentKey: 0,
        useUnitsLayout: this.product.units.length > 0 && this.productDetailsPage
        // END BESPOKE EDEX
      };
    },
    computed: {
      ...mapGetters(['stockLimit', 'showStock']),
      // BESPOKE EDEX-46
      selectedUnitFactor() {
        const unit = this.product.units.filter(unit => unit.code === this.selectedUnitCode);
        return unit[0].quantity;
      },
      // END BESPOKE EDEX-46
      orderCommentField() {
        return this.orderComment;
      },
      isValidQuantity() {
        if (this.stockLimit && this.stockProduct && this.product.stock.stockTotal !== null) {
          if (this.useOrderMode || this.totalOrderLinesQuantity === null) {
            return this.quantity <= this.product.stock.stockTotal;
          } else {
            return this.totalOrderLinesQuantity <= this.product.stock.stockTotal;
          }
        } else {
          return true;
        }
      }
    },
    watch: {
      product() {
        this.setOrderType();
        this.setOrderQuantities();
      }
    },
    methods: {
      setOrderType() {
        let type = 'normal';
        if (this.product.units) {
          type = 'units';
        } else if (this.product.saleUnit > 1) {
          type = 'saleUnit';
        }
        this.orderType = type;
      },
      setOrderQuantities() {
        switch (this.orderType) {
          case 'normal':
            this.quantityFactor = 1;
            if (this.allowZeroQuantity) {
              this.quantity = 0;
            } else {
              this.quantity = this.initialQuantity > this.quantityFactor ? this.initialQuantity : this.quantityFactor;
            }
            break;
          case 'saleUnit':
            const initialQuantity = this.initialQuantity * this.product.saleUnit;
            this.quantityFactor = this.product.saleUnit;
            if (this.allowZeroQuantity) {
              this.quantity = 0;
            } else {
              this.quantity = initialQuantity > this.quantityFactor ? initialQuantity : this.quantityFactor;
            }
            break;
          case 'volumeDiscount':
            this.quantityFactor = this.product.prices[0].quantity;
            this.quantity = this.initialQuantity > this.quantityFactor || this.allowZeroQuantity ? 0 : this.quantityFactor;
            break;
          case 'units':
            let index = 0;
            if (this.initialUnitCode) {
              this.product.units.filter((unit, i) => {
                if (unit.code === this.initialUnitCode) {
                  index = i;
                }
              });
            }
            this.selectedUnitCode = this.product.units[index].code;
            this.quantityFactor = this.product.units[index].quantity;
            if (this.allowZeroQuantity) {
              this.quantity = 0;
            } else {
              // BESPOKE EDEX
              // When on the the shoppingcart page, do not multiiply quantity times factor
              if (this.initialUnitCode) {      
                this.quantityFactor = 1;          
                this.quantity = this.initialQuantity > 1 ? this.initialQuantity : 1;
              // When not on the shoppingcart page, initial state is usually 1
              } else {
                this.quantityFactor = 1;
                this.quantity = 1;
              }
              // END BESPOKE EDEX
            }
            
            break;
        }
      },
      orderProduct() {
        let payload = this.getOrderPayload();
        this.addToCart(payload)
          .then(res => {
            this.quantity = this.quantityFactor;
          });
      },
      getOrderPayload() {
        return {
          prod_code: this.product.id,
          ord_qty: this.getComputedQuantity(this.quantity),
          unit_code: this.selectedUnitCode,
          prod_comment: this.useOrderComment ? this.$refs.orderComment.value : ''
        }
      },
      getComputedQuantity(quantity) {
        let computedQuantity = quantity;
        if (this.orderType === 'units') {
           // BESPOKE EDEX-46
          // Do not use factor increases in the quantity field
          // computedQuantity = this.quantity / this.quantityFactor;
          // END BESPOKE EDEX-46
        } else if (this.orderType === 'volumeDiscount' && this.product.saleUnit > 1) {
          computedQuantity = this.quantity / this.product.saleUnit;
        } else if (this.orderType === 'saleUnit') {
          computedQuantity = this.quantity / this.product.saleUnit;
        }
        return computedQuantity;
      },
      quantityChanged({ quantity }) {
        this.quantity = quantity;
        if (!this.useOrderMode) {
          this.$emit('quantityChanged', {
            id: this.product.id,
            unitCode: this.selectedUnitCode,
            computedQuantity: this.getComputedQuantity(this.quantity)
          });
        }
      },
      unitsChanged({ quantity, unitCode }) {
        this.selectedUnitCode = unitCode;
        // BESPOKE EDEX-46
        // DO not take units factors into account
        this.quantity = 1;
        this.quantityFactor = 1;
        // END BESPOKE EDEX-46
        if (!this.useOrderMode) {
          this.$emit('unitsChanged', {
            unitCode: unitCode,
            quantity: quantity,
            computedQuantity: this.getComputedQuantity(this.quantity)
          });
        }
      },
      volumeDiscountChanged(quantity) {
        this.quantity = quantity;
        this.quantityFactor = quantity;
      },
      ...mapActions('shoppingCart', ['addToCart']),
      // BESPOKE EDEX
      // Added methods to handle the custom units layout on the product details page
      // where we show each unit with it's own quantity control 
      setCustomUnits () {
        this.product.units.forEach(unit => {
          this.customUnits[unit.code] = {
              selectedQuantity: 0,
              quantity: unit.quantity,
              code: unit.code,
              description: unit.description,
              eanCode: this.product.customStrings['UNIT_' + unit.code]
            }
        });
      },
      customQuantityChanged ({quantity}, unitCode) {
        this.customUnits[unitCode].selectedQuantity = quantity;
      },
      orderProductAsUnits () {
        let payload = []; 
        Object.keys(this.customUnits).forEach(unitCode => {
          if (this.customUnits[unitCode].selectedQuantity > 0) {
            payload.push({
              prod_code: this.product.id,
              ord_qty: this.customUnits[unitCode].selectedQuantity,
              unit_code: unitCode,
              prod_comment: ''
            })
          }
        });

        this.addToCart(payload)
          .then(res => {
            payload.forEach(line => {
              this.customUnits[line.unit_code].selectedQuantity = 0;
            });
            this.componentKey++;
          });
      }
      // END BESPOKE EDEX
    },
    created() {
      this.setOrderType();
      this.setOrderQuantities();
      // BESPOKE EDEX
      if (this.useUnitsLayout) {
        this.setCustomUnits();
      }
      // END BESPOKE EDEX
    }
  };
</script>

<style>
</style>
